// extracted by mini-css-extract-plugin
module.exports = {"proposal_status":"ProposalStatus_proposal_status__3L19q","title":"ProposalStatus_title__3SYFe","image":"ProposalStatus_image__1fbAI"};